// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__2yAi2","item1":"style_item1__21z4X","recipesList":"style_recipesList__3sBSM","filter":"style_filter__1_HgQ","helper":"style_helper__1Uhnb"};